import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ImageField,
  ArrayField,
  SingleFieldList,
  ChipField,
  useRecordContext,
  Filter,
  TextInput,
  SelectInput,
} from "react-admin";
import { TimeField } from "../../components/common/TimeField";
import { PartialTextField } from "../../components/common/PartialTextField";

import { makeStyles } from "@material-ui/core/styles";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

export const HideStatusField = ({ source }) => {
  const record = useRecordContext();
  if (!record) return null;

  const isHidden = record[source];

  return (
    <FiberManualRecordIcon
      style={{
        color: isHidden ? "red" : "green",
        fontSize: 28,
        verticalAlign: "middle",
      }}
      titleAccess={isHidden ? "Hidden" : "Visible"}
    />
  );
};

const useStyles = makeStyles({
  root: {
    display: "flex",
    "& img": {
      maxHeight: "5rem",
    },
  },
});

const NotificationFilter = (props) => (
  <Filter {...props}>
    {/* Search by title */}
    <TextInput label="Search by Title" source="title" alwaysOn />

    {/* Filter by visibility */}
    <SelectInput
      label="Visibility"
      source="hide"
      choices={[
        { id: "", name: "All" },
        { id: false, name: "Visible" },
        { id: true, name: "Hidden" },
      ]}
      alwaysOn
    />
  </Filter>
);

export const NotificationList = ({ permissions, ...props }) => {
  const classes = useStyles();

  return (
    <List
      {...props}
      exporter={false}
      filters={<NotificationFilter />}
      sort={{ field: "id", order: "DESC" }}
    >
      <Datagrid
        rowClick="show"
        bulkActionButtons={permissions === "admin" ? true : false}
      >
        <TextField label="Id" source="id" />
        <HideStatusField label="Visibility" source="hide" />
        <TextField label="Title" source="title" />
        <PartialTextField
          maxLength={200}
          style={{ width: 250 }}
          source="details"
        />
        <ImageField
          className={classes.root}
          label="Image URL"
          source="img_url"
        />
        <TimeField label="Published" source="publish_date" />
        <TextField source="cta" />
        <ArrayField source="groups" label="Categories">
          <SingleFieldList>
            <ChipField source="title" color="secondary" />
          </SingleFieldList>
        </ArrayField>
        <ArrayField source="tags" label="Tags">
          <SingleFieldList>
            <ChipField source="title" color="default" />
          </SingleFieldList>
        </ArrayField>
        <TimeField label="Created" source="createdAt" />
        <TimeField label="Updated" source="updatedAt" />
      </Datagrid>
    </List>
  );
};
